import styled from 'styled-components';
import { IStyleProps } from '../interfaces';

//------------ FLEX DESIGNS---------------//
// https://tburleson-layouts-demos.firebaseapp.com/

export const FlexContainer = styled.div<IStyleProps>`
  flex: ${props => props.size};
  display: flex;
  justify-content: ${props => props.justifyContent};
  align-items: ${props => props.alignItems};
  flex-direction: ${props => props.fxLayout};
  flex-wrap: ${props => props.fxWrap};
  width: ${props => props.width};
  place-content: ${props => props.placeContent};
  padding: ${props => props.padding};
  gap: ${props => (props.spacing ? `${props.spacing}px` : '0px')};
  background-color: ${props => props.bgColor};
  margin: ${props => props.margin};
  border: ${props => props.border};
  &.spacing-60 {
    gap: 60px;
    .styled-chkbox {
      white-space: nowrap;
    }
  }
  @media (max-width: 768px) {
    &.spacing-60 {
      gap: 20px;
      .styled-chkbox {
        white-space: nowrap;
      }
    }
  }
  @media (min-width: 769px) and (max-width: 1300px) {
    &.spacing-60 {
      gap: 30px;
      .styled-chkbox {
        white-space: nowrap;
      }
    }
  }
`;

FlexContainer.defaultProps = {
  size: 1,
  alignItems: 'start',
  justifyContent: 'start',
  width: '100%',
  fxLayout: 'row',
  spacing: 0, // Give space between child elements
  padding: '0',
  fxWrap: 'nowrap',
  border: 'none',
};
